// region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Main application file
//
//  Copyright:    © 2025 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
// region Version 1.0.0.0
//    001   20.02.25 Sean Flook          GMSCM-1 Initial Revision.
//    002   12.03.25 Sean Flook          GMSCM-1 Code required for managing the configuration and cluster documents.
// endregion Version 1.0.0.0
//
//--------------------------------------------------------------------------------------------------
// endregion header

import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StyledEngineProvider, ThemeProvider, createTheme } from "@mui/material/styles";

import "./App.css";
import router from "./routes";

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: '"Nunito Sans", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      h1: { fontSize: "24px", fontWeight: 500, letterSpacing: 0 },
      h2: { fontSize: "21px", fontWeight: 400, letterSpacing: 0 },
      h3: { fontSize: "17px", fontWeight: 400, letterSpacing: 0 },
      h4: { fontSize: "16px", fontWeight: 500, letterSpacing: 0 },
      h5: { fontSize: "15px", fontWeight: 500, letterSpacing: 0 },
      body1: { fontSize: "15px", fontWeight: 400, letterSpacing: 0 },
      body2: { fontSize: "14px", fontWeight: 400, letterSpacing: 0 },
      caption: { fontSize: "13px", fontWeight: 400, letterSpacing: 0 },
      button: { fontSize: "15px", fontWeight: 400, letterSpacing: 0, textTransform: "none" },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
      },
      MuiBadge: {
        styleOverrides: {
          badge: {
            fontFamily: '"Open Sans", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            fontSize: "13px",
            fontWeight: 400,
            letterSpacing: 0,
          },
        },
      },
    },
  });

  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <RouterProvider router={router} />
          <ReactQueryDevtools />
        </ThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  );
}

export default App;
